// Import everything from autoload
import "./autoload/_bootstrap.js";
import Highway from "@dogstudio/highway";
import Factory from "@lib/Factory";
import ticker from "@lib/plugins/ticker";
import resize from "@lib/plugins/resize";

/**
 * Routes
 */
import defaultRenderer from "@lib/Page";
import components from "./pages/components";

/**
 * Components
 */
import Input from "./components/Input";
import NewsList from "./components/NewsList";
import ScrollTop from "./components/ScrollTop";
import SearchInput from "./components/SearchInput";
import Video from "./components/Video";
import Debug from "./components/Debug";
import MayInterest from "./components/MayInterest";
import HomeDiscover from "./components/HomeDiscover";
import HomeNews from "./components/HomeNews";
import RecruitmentForm from "./components/RecruitmentForm";
import ModalVideo from "./components/ModalVideo";
import Discover from "./components/Discover";
import Nav from "./components/Nav";
import AgentAffiliate from "./components/AgentAffiliate";
import Partners from "./components/Partners";
import ImageSlider from "./components/ImageSlider";
import Image from "./components/Image";
import MapBox from "./components/MapBox.js";
import RecruitmentList from "./components/RecruitmentList.js";
import SiteChoiceModal from "./components/SiteChoiceModal";
import Findseller from "./components/Findseller";

/**
 * Transitions
 */
import DefaultTransition from "./transitions/defaultTransition";
import { qs } from "@qneyraud/q-utils/umd/q-utils";

ticker();
resize();

Factory.matchComponents({
  "scroll-top": ScrollTop,
  "news-list": NewsList,
  "recruitment-list": RecruitmentList,
  "search-input": SearchInput,
  image: Image,
  "image-slider": ImageSlider,
  "site-choice-modal": SiteChoiceModal,
  partners: Partners,
  "agent-affiliate": AgentAffiliate,
  debug: Debug,
  video: Video,
  input: Input,
  "may-interest": MayInterest,
  "home-discover": HomeDiscover,
  "home-news": HomeNews,
  "modal-video": ModalVideo,
  discover: Discover,
  nav: Nav,
  mapbox: MapBox,
  findseller: Findseller
});

const modalVideo = Factory.createComponent(qs(document, ".modal-video"), {});
modalVideo.createElement();
modalVideo.init();

const siteChoiceModalInstance = Factory.createComponent(qs(document, ".site-choice-modal"), {});
siteChoiceModalInstance.createElement();
siteChoiceModalInstance.init();
siteChoiceModalInstance.onEnterCompleted();

const H = Highway.Core({
  renderers: {
    components,
    default: defaultRenderer
  },
  transitions: {
    default: DefaultTransition
  }
});

H.on("NAVIGATE_IN", () => {
  if (typeof window.gformInitializeOnLoaded === "function") {
    window.gformInitializeOnLoaded(); // Recharge Gravity Forms
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js